import { RefObject, useEffect, useState } from 'react';

// Tracks whether the referenced element's content overflows its visible width
// (i.e. is being clipped or ellipsized). Re-evaluates on element resize and
// whenever any of the optional `deps` change (e.g. when content updates).
export const useIsOverflowing = (
  ref: RefObject<HTMLElement | null>,
  deps: unknown[] = [],
): boolean => {
  const [overflowing, setOverflowing] = useState<boolean>(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return undefined;
    }

    const checkOverflow = () => {
      setOverflowing(element.offsetWidth < element.scrollWidth);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, ...deps]);

  return overflowing;
};
